import { Typography, Grid, withStyles, Theme } from '@material-ui/core'
import { ReactNode } from 'react'
import { MuiClasses } from '../../types'
//import buildingType from '../../images/afterShowing/buildingType.svg'
import euro from '../../images/afterShowing/euro.svg'
import locationPin from '../../images/afterShowing/locationPin.svg'
import rooms from '../../images/afterShowing/rooms.svg'
import squareMeters from '../../images/afterShowing/squareMeters.svg'
import yearBuilt from '../../images/afterShowing/yearBuilt.svg'
import i18n from '../../translations/i18n'

type ApartmentInfoSuggestProps = {
    apartment: any
    classes: MuiClasses
    content?: string
    isModal?: boolean
    hideSuggestIcon?: boolean
    customSuggestTextStyles?: string
    containerStyle?: string
    suggestContainerStyle?: string
    renderText?: () => ReactNode
    handleClick?: () => void
    clickable?: boolean,
    t: i18n.TFunction
}
const styles = ({ breakpoints, typography }: Theme) => ({
    largeForm: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        justifySelf: 'center',
        [breakpoints.down('sm')]: {
            padding: '10px 0'
        },
        [breakpoints.up('lg')]: {
            display: 'flex'
        }
    },
    suggestContainer: {
        background: '#E7ECEF',
        display: 'flex',
        justifyContent: 'space-between',
        fontSize: '12px',
        borderRadius: '25px',
        padding: '3rem',
        alignItems: 'flex-start',
        gap: '1.25rem',
        alignSelf: 'stretch',
        flexWrap: 'wrap',
        [breakpoints.down('sm')]: {
            '& > div': {
                flexBasis: 'calc(50% - 1.25rem)',
                maxWidth: 'calc(50% - 1.25rem)',
            },
            padding: '1.5rem',
            flexWrap: 'wrap !important',
        },
        '& img': {
            marginRight: '10px',
            marginBottom: '10px'
        }
    },
    childStyle: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        gap: '0.375rem'
    },
    firstChild: {
        [breakpoints.down('sm')]: {
            margin: 'auto',
            flexBasis: 'unset !important',
            maxWidth: '100% !important',
            width: '100%',
            display: 'flex',
            justifyContent: 'center',
        }
    },
    w13: {
        width: '13%'
    },
    w80: {
        width: '100%',
        [breakpoints.down('sm')]: {
            display: 'flex',
            flexDirection: 'column'
        }
    },
    wfull: {
        width: '100%'
    },
    containerStyle: {
        display: 'flex',
        alignItems: 'flex-start',
        gap: '1.25rem',
        alignSelf: 'stretch'
    },
    infoHeader: {
        color: '#9EA4A8',
        fontFamily: 'CircularRegular',
        fontSize: '0.875rem',
        fontStyle: 'normal',
        fontWeight: typography.fontWeightLight,
        lineHeight: '1.25rem' // 142.857%
    },
    infoData: {
        color: '#000',
        fontFamily: 'CircularRegular',
        fontSize: '1.125rem',
        fontStyle: 'normal',
        fontWeight: typography.fontWeightLight,
        lineHeight: '1.25rem'
    }
})

const ApartmentInfoSuggest = ({
    classes,
    containerStyle,
    renderText,
    handleClick,
    clickable,
    apartment,
    t
}: ApartmentInfoSuggestProps) => {
    return (
        <div>
            <Grid
                container
                onClick={handleClick}
                className={`${classes.suggestContainer} ${classes.containerStyle} ${clickable ? classes.cursorPointer : ''}`}
                style={{ flexWrap: 'nowrap' }}
            >
                <div className={`${classes.childStyle} ${classes.firstChild}`}>
                    <img src={locationPin} alt="Location" style={{ marginBottom: '0px' }} />
                    <span className={`${classes.infoHeader}`}>{t('afterShowing.apartmentAddress')}</span>
                    <span className={`${classes.infoData}`}>{`${apartment.information.address}, ${apartment.information.postalCode} ${apartment.information.postalArea}`}</span>
                </div>
                <div className={`${classes.childStyle}`}>
                    <img src={rooms} alt="Rooms" style={{ marginBottom: '0px' }} />
                    <span className={`${classes.infoHeader}`}>{t('afterShowing.rooms')}</span>
                    <span className={`${classes.infoData}`}>{`${apartment.information.rooms.replace(/\D/g, '')}`}</span>
                </div>
                <div className={`${classes.childStyle}`}>
                    <img src={euro} alt="Euro" style={{ marginBottom: '0px' }} />
                    <span className={`${classes.infoHeader}`}>{t('afterShowing.rentPrice')}</span>
                    <span className={`${classes.infoData}`}>{`${apartment.confirmation.price}`}</span>
                </div>
                <div className={`${classes.childStyle}`}>
                    <img src={squareMeters} alt="Square Meters" style={{ marginBottom: '0px' }} />
                    <span className={`${classes.infoHeader}`}>{t('afterShowing.squareMeters')}</span>
                    <span className={`${classes.infoData}`}>{`${apartment.information.squareMeters}`}</span>
                </div>
                {/* <div className={`${classes.childStyle}`}>
                    <img src={buildingType} alt="Building Type" />
                    <p>Building type:</p>
                    <p>Text Row 1.2</p>
                </div> */}
                <div className={`${classes.childStyle}`}>
                    <img src={yearBuilt} alt="Year Built" style={{ marginBottom: '0px' }} />
                    <span className={`${classes.infoHeader}`}>{t('afterShowing.yearBuilt')}</span>
                    <span className={`${classes.infoData}`}>{`${apartment.information.buildYear}`}</span>
                </div>
            </Grid>
        </div>
    )
}
export default withStyles(styles)(ApartmentInfoSuggest)
